import { Number } from 'stdlib/Number'

/**
 * A root top és left-jét ennek a segítségével számoljuk ki.
 * @param base - A window width-e, vagy height-je.
 * @param size - A scaledSize.
 */
export default function halfPx (base: number, size: number): string {
  const diff    = base - size
  const rounded = Math.round(Number.half(diff))
  const px      = `${ rounded }px`

  return px
}
